import { getBlockchainProof } from './states';

export const services = {
  getBlockchainProof,
};
